import { render, staticRenderFns } from "./TabelaPerfis.vue?vue&type=template&id=fe5525e2&"
import script from "./TabelaPerfis.vue?vue&type=script&lang=js&"
export * from "./TabelaPerfis.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPerfis.vue?vue&type=style&index=0&id=fe5525e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports